<template>
  <div id="Inicio" class="inicio">
    <!-- Hero Section -->
    <div class="hero-section">
      <div class="hero-background">
        <div class="floating-shapes">
          <div class="shape shape-1"></div>
          <div class="shape shape-2"></div>
          <div class="shape shape-3"></div>
          <div class="shape shape-4"></div>
        </div>
      </div>
      
      <div class="container">
        <div class="hero-content" data-aos="fade-up" data-aos-duration="800">
          <!-- Logo Section -->
          <div class="logo-section" data-aos="zoom-in" data-aos-delay="200">
            <div class="logo-container">
              <img src="@/assets/imag/v1/logos/logo_main.svg" alt="PEUMO Logo" class="logo">
            </div>
          </div>
          
          <!-- Main Content -->
          <div class="main-content">
            <h1 class="hero-title">
              <span class="gradient-text">¡Bienvenido a PEUMO!</span>
            </h1>
            <p class="hero-subtitle" data-aos="fade-up" data-aos-delay="300">
              Tu asistente inteligente para mejorar la escritura académica en ingeniería
            </p>
            
            <!-- File Upload Section -->
            <div class="upload-section" data-aos="fade-up" data-aos-delay="400">
              <div class="upload-card glass-effect">
                <div class="upload-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16 13H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16 17H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10 9H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <h3 class="upload-title">Carga tu documento</h3>
                <p class="upload-description">Formatos soportados: DOC, DOCX, TXT</p>
                
                <div class="upload-area" @click="triggerFileUpload" :class="{ 'drag-over': isDragOver }">
                  <input 
                    ref="file" 
                    type="file" 
                    id="file" 
                    style="display: none" 
                    @change="handleFileUpload"
                    accept=".doc,.docx,.txt"
                  />
                  <div class="upload-content">
                    <div class="upload-icon-large">
                      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M17 8L12 3L7 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 3V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <p class="upload-text">{{ fileInputLabel }}</p>
                    <p class="upload-hint">Haz clic para seleccionar o arrastra tu archivo aquí</p>
                  </div>
                </div>
              </div>
              
              <!-- Alternative Option -->
              <div class="alternative-section" data-aos="fade-up" data-aos-delay="500">
                <div class="divider">
                  <span>o</span>
                </div>
                <button class="btn btn-outline" @click="goToDashboard">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Comienza escribiendo en nuestro editor
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Features Section -->
    <div class="features-section" data-aos="fade-up" data-aos-delay="600">
      <div class="container">
        <h2 class="features-title">Características Principales</h2>
        <div class="features-grid">
          <div class="feature-card" data-aos="fade-up" data-aos-delay="700">
            <div class="feature-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h4>Análisis Inteligente</h4>
            <p>Detecta errores gramaticales y de estilo automáticamente</p>
          </div>
          
          <div class="feature-card" data-aos="fade-up" data-aos-delay="800">
            <div class="feature-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h4>Retroalimentación Detallada</h4>
            <p>Recibe sugerencias específicas para mejorar tu escritura</p>
          </div>
          
          <div class="feature-card" data-aos="fade-up" data-aos-delay="900">
            <div class="feature-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h4>Rápido y Eficiente</h4>
            <p>Procesa tus documentos en segundos con resultados precisos</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "Inicio",
  components: {
  },
  data() {
    return {
      isDragOver: false
    };
  },
  computed: {
    ...mapGetters({retroalimentacion: "getRetroalimentacion", fileName: "getFilename", analysisType: "getAnalysisTab"}),
    fileInputLabel: function () {
      if (this.retroalimentacion.html) return "Reemplazar el documento";
      return "Carga tu texto aquí"
    }
  },
  mounted() {
    // Add drag and drop event listeners
    this.addDragAndDropListeners();
  },
  beforeDestroy() {
    // Clean up event listeners
    this.removeDragAndDropListeners();
  },
  methods: {
    ...mapActions([
      "saveEstadisticasGenerales",
      "saveGerundios",
      "saveOraciones",
      "saveParrafos",
      "savePersona",
      "saveVozPasiva",
      "saveConectores",
      "saveComplejidad",
      "saveLecturabilidad",
      "saveProposito",
      "saveFilename",
      "saveAnalisisPantalla"
    ]),
    triggerFileUpload() {
      this.$refs.file.click();
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.saveFilename(this.file.name);
      this.onSubmit();
      this.$router.push({ path: 'Dashboard' })
    },
    goToDashboard(){
      this.$router.push({ path: 'Dashboard' })
    },
    addDragAndDropListeners() {
      const uploadArea = document.querySelector('.upload-area');
      if (uploadArea) {
        uploadArea.addEventListener('dragover', this.handleDragOver);
        uploadArea.addEventListener('dragleave', this.handleDragLeave);
        uploadArea.addEventListener('drop', this.handleDrop);
      }
    },
    removeDragAndDropListeners() {
      const uploadArea = document.querySelector('.upload-area');
      if (uploadArea) {
        uploadArea.removeEventListener('dragover', this.handleDragOver);
        uploadArea.removeEventListener('dragleave', this.handleDragLeave);
        uploadArea.removeEventListener('drop', this.handleDrop);
      }
    },
    handleDragOver(e) {
      e.preventDefault();
      this.isDragOver = true;
    },
    handleDragLeave(e) {
      e.preventDefault();
      this.isDragOver = false;
    },
    handleDrop(e) {
      e.preventDefault();
      this.isDragOver = false;
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        this.file = files[0];
        this.saveFilename(this.file.name);
        this.onSubmit();
        this.$router.push({ path: 'Dashboard' });
      }
    },
    async onSubmit() {
      const formData = new FormData();
      formData.append("file", this.file);
      if (!this.file) {
        this.makeToast("No se adjuntó el archivo.", "danger");
        return 0;
      }
      let extension = this.file.name.split(".")[1];
      let loader = this.$loading.show({ isFullPage: true, canCancel: false });
      try {
        if (!["docx", "doc", "txt"].includes(extension)) {
          throw new Error(
            "Archivo no soportado, utilice documentos con extensión .doc, .docx o .txt"
          );
        }
        let res = await axios.post(
          `${process.env.VUE_APP_API_URL}/api/FileUploadView`,
          formData
        );
        this.saveEstadisticasGenerales(res.data.statistics);
        this.saveGerundios({
          html: res.data.gerunds.html_response,
          error: res.data.gerunds.flag,
        });
        this.saveOraciones({
          html: res.data.oraciones.html_response,
          error: res.data.oraciones.flag,
        });
        this.saveParrafos({
          html: res.data.micro_paragraphs.html_response,
          error: res.data.micro_paragraphs.flag,
        });
        this.savePersona({
          html: res.data.fs_person.html_response,
          error: res.data.fs_person.flag,
        });
        this.saveVozPasiva({
          html: res.data.passive_voice.html_response,
          error: res.data.passive_voice.flag,
        });
        this.saveConectores({
          html: res.data.conectores.html_response,
          error: res.data.conectores.flag,
        });
        this.saveComplejidad({
          html: res.data.sentence_complexity.html_response,
          error: res.data.sentence_complexity.flag,
        });
        this.saveLecturabilidad({
          html: res.data.lecturabilidad_parrafo.html_response,
          error: res.data.lecturabilidad_parrafo.flag,
        });
        this.saveProposito({
          html: res.data.proposito.html_response,
          error: res.data.proposito.flag,
        });
        this.saveAnalisisPantalla({endpoint: "gerunds", selected: "gerundios"});
        this.makeToast("Documento analizado correctamente.", "success");
      } catch (err) {
        console.warn(err);
        this.makeToast(err, "danger");
      } finally {
        loader.hide();
      }
    },
    makeToast(message, variant) {
      let title =
        variant == "success" ? "Operación exitosa" : "Operación fallida";
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: false,
        autoHideDelay: 2000,
      });
    }
  }
};
</script>
<style scoped>
/* Override old styles */
#Inicio.inicio {
  background: none !important;
  height: auto !important;
  min-height: auto !important;
  overflow: visible !important;
  position: relative !important;
}

/* Force features section visibility */
.features-section {
  visibility: visible !important;
  opacity: 1 !important;
  display: block !important;
  position: relative !important;
  overflow: visible !important;
}

.features-section * {
  visibility: visible !important;
  opacity: 1 !important;
  display: block !important;
}

#Inicio.inicio .auxi {
  max-width: none !important;
}

#Inicio.inicio .content-main {
  height: auto !important;
  display: block !important;
  -webkit-box: none !important;
  -webkit-flex: none !important;
  flex: none !important;
  -webkit-flex-direction: none !important;
  flex-direction: none !important;
  -webkit-justify-content: none !important;
  justify-content: none !important;
  -webkit-align-items: none !important;
  align-items: none !important;
  background-image: none !important;
  background-position: none !important;
  background-repeat: none !important;
}

/* Hero Section */
.hero-section {
  min-height: 70vh !important;
  display: flex !important;
  align-items: center !important;
  position: relative !important;
  overflow: visible !important;
}

.hero-background {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  z-index: -2 !important;
}

.floating-shapes {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 6s ease-in-out infinite;
}

.shape-1 {
  width: 80px;
  height: 80px;
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 120px;
  height: 120px;
  top: 60%;
  right: 15%;
  animation-delay: 2s;
}

.shape-3 {
  width: 60px;
  height: 60px;
  top: 80%;
  left: 20%;
  animation-delay: 4s;
}

.shape-4 {
  width: 100px;
  height: 100px;
  top: 10%;
  right: 30%;
  animation-delay: 1s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

.hero-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  text-align: center;
}

.logo-section {
  margin-bottom: 3rem;
}

.logo-container {
  display: inline-block;
  padding: 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.logo {
  width: 80px;
  height: 80px;
  filter: brightness(0) invert(1);
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 3rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

/* Upload Section */
.upload-section {
  max-width: 600px;
  margin: 0 auto;
}

.upload-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 1.5rem;
  padding: 2rem;
  text-align: center;
  margin-bottom: 2rem;
}

.upload-icon {
  margin-bottom: 1rem;
  color: rgba(255, 255, 255, 0.8);
}

.upload-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: white;
  margin-bottom: 0.5rem;
}

.upload-description {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 2rem;
}

.upload-area {
  border: 2px dashed rgba(255, 255, 255, 0.3);
  border-radius: 1rem;
  padding: 3rem 2rem;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.05);
}

.upload-area:hover,
.upload-area.drag-over {
  border-color: rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.upload-content {
  color: white;
}

.upload-icon-large {
  margin-bottom: 1rem;
  color: rgba(255, 255, 255, 0.8);
}

.upload-text {
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.upload-hint {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.7);
}

/* Alternative Section */
.alternative-section {
  text-align: center;
}

.divider {
  position: relative;
  margin: 2rem 0;
  color: rgba(255, 255, 255, 0.7);
}

.divider::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.3);
}

.divider span {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 0 1rem;
  position: relative;
  z-index: 1;
}

.btn-outline {
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 0.875rem 2rem;
  border-radius: 0.75rem;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
}

.btn-outline:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.6);
  transform: translateY(-2px);
}

/* Features Section */
.features-section {
  padding: 4rem 0 !important;
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px) !important;
  display: block !important;
  width: 100% !important;
  min-height: 400px !important;
  position: relative !important;
  z-index: 10 !important;
  margin-top: 2rem !important;
  border-top: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.features-title {
  text-align: center !important;
  font-size: 2.5rem !important;
  font-weight: 700 !important;
  color: white !important;
  margin-bottom: 3rem !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
}

.features-grid {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)) !important;
  gap: 2rem !important;
  max-width: 1200px !important;
  margin: 0 auto !important;
  padding: 0 2rem !important;
}

.feature-card {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 1rem !important;
  padding: 2rem !important;
  text-align: center !important;
  transition: all 0.3s ease !important;
  display: block !important;
  width: 100% !important;
  min-height: 200px !important;
  position: relative !important;
  z-index: 2 !important;
}

.feature-card:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.15);
}

.feature-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.feature-card h4 {
  font-size: 1.25rem !important;
  font-weight: 600 !important;
  color: white !important;
  margin-bottom: 1rem !important;
  display: block !important;
}

.feature-card p {
  color: rgba(255, 255, 255, 0.8) !important;
  line-height: 1.6 !important;
  display: block !important;
  margin: 0 !important;
}

.feature-icon {
  width: 64px !important;
  height: 64px !important;
  margin: 0 auto 1.5rem !important;
  background: rgba(255, 255, 255, 0.1) !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: white !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-title {
    font-size: 2.5rem;
  }
  
  .hero-subtitle {
    font-size: 1.125rem;
  }
  
  .upload-card {
    padding: 1.5rem;
  }
  
  .upload-area {
    padding: 2rem 1rem;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .logo {
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 480px) {
  .hero-content {
    padding: 1rem;
  }
  
  .hero-title {
    font-size: 2rem;
  }
  
  .upload-card {
    padding: 1rem;
  }
  
  .upload-area {
    padding: 1.5rem 1rem;
  }
  
  .feature-card {
    padding: 1.5rem;
  }
}
</style>